import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { FiscalGroup } from "@shared/models/fiscal-group"
import type Rpc from "cc-frontend/services/rpc"

export interface ChangeGroupStateSignature {
  Args: {
    model: { fiscalGroup: FiscalGroup }
    order: number
    closeModal: () => void
  }
}

export default class ChangeGroupStateComponent extends Component<ChangeGroupStateSignature> {
  @service declare rpc: Rpc

  @tracked
  newGroupState: FiscalGroup["attributes"]["groupState"]

  constructor(owner: unknown, args: ChangeGroupStateSignature["Args"]) {
    super(owner, args)

    this.newGroupState = args.model.fiscalGroup.attributes.groupState
  }

  @action
  setGroupState(state: "open" | "closed" | "locked") {
    this.newGroupState = state
  }

  @action
  saveGroupStateChange() {
    if (window.confirm(`Confirm: Changing group state to "${this.newGroupState}".`)) {
      this.rpc.execute("fiscalgroup_admin_change_group_state", {
        fiscalGroupId: this.args.model.fiscalGroup.id,
        groupState: this.newGroupState,
      })
    }
    this.args.closeModal()
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Admin::FiscalGroup::ChangeGroupState": ChangeGroupStateComponent
  }
}
